import { render, staticRenderFns } from "./send-rule-preview-other.vue?vue&type=template&id=05dc5b87&"
import script from "./send-rule-preview-other.vue?vue&type=script&lang=js&"
export * from "./send-rule-preview-other.vue?vue&type=script&lang=js&"
import style0 from "./send-rule-preview-other.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports